import React, {useState, useEffect} from 'react'

import {Dropdown} from 'semantic-ui-react'

import {GetTotalGroupStageMatches} from '../utils/TourGenerator'


const timeOptions = [
    {
        key : '5',
        text: '5 Minute',
        value : 5
    },
    {
        key : '10',
        text: '10 Minute',
        value : 10
    ,
    },
    {
        key : '15',
        text : '15 Minute',
        value : 15
    },
    {
        key : '20',
        text : '20 Minute',
        value : 20
    },
    {
        key : '25',
        text : '25 Minute',
        value : 25
    },
    {
        key : '30',
        text : '30 Minute',
        value : 30
    }
    
]

const calulcateEndTime = (minutesPrMatch:number, matchCount:number) => {
    const now = new Date();    
    now.setMinutes(now.getMinutes() + (minutesPrMatch * matchCount))
    return now;
}

const TimeEstimator = (props:{groupStageMatchCount:number, playerCount:number}) => {
    const [minutesPrMatch, setMinutesPrMatch] = useState<number>(parseInt(timeOptions[1].value + '', 10));
    const [estimatedTimeEnd, setEstimatedTimeEnd] = useState<Date>(calulcateEndTime(minutesPrMatch, props.groupStageMatchCount));

    
    useEffect(() => {
        const totalMatches = GetTotalGroupStageMatches(props.playerCount, props.groupStageMatchCount);
        setEstimatedTimeEnd(calulcateEndTime(minutesPrMatch, totalMatches));
    }, [minutesPrMatch, props.groupStageMatchCount, props.playerCount])

    const onChange = (e:any, val:any) => {
        setMinutesPrMatch(val);
    }

    const formatedDate = () => {
        let hour = estimatedTimeEnd.getHours() < 10 ? '0' : '';
        hour =  hour + estimatedTimeEnd.getHours();
        let mins = estimatedTimeEnd.getMinutes() < 10 ? '0' : '';
        mins =  mins + estimatedTimeEnd.getMinutes();
        return hour + ':' + mins;
    }

    return(
        <div>
        <p>
            With estimated{' '}
            <Dropdown
                className='button melee basic icon'
                floating
                inline
                icon='time'
                onChange={(e:any,{value}) => onChange(e, value)}
                options={timeOptions}
                value={minutesPrMatch}
                defaultValue={minutesPrMatch}
            />
            {' '}matches, group stage will end at <b>{formatedDate()}</b>
        </p>
        </div>
    )
}

export default TimeEstimator;